<template>
  <section class="header mt-3 mt-md-0 referral-page-header__container">
    <div class="header-body">
      <div class="row align-items-center">
        <div class="col">
          <h6 class="header-pretitle">
            지인 초대 & 혜택
          </h6>
          <h1 class="header-title">
            {{ centerAccount.name }}
          </h1>
        </div>
        <div class="col-auto">
          <slot />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ReferralHeader',
    computed: {
    ...mapGetters({
      centerAccount: "getCenterAccount"
    }),
	},
};
</script>

<style lang="scss">
.header-title{
    white-space: nowrap;
}
.referral-page-header__container{
    border-bottom: 1px solid #d3d3d3;
     @media screen and (max-width: 768px) {
        width: 100%;
    }
    .col{
        padding-bottom: 18px;
        @media screen and (max-width: 768px) {
            width: 100%;
            flex-basis: initial;
        }
    }
    .col-auto{
        @media screen and (max-width: 768px) {
            width: 100%;
        }
    }
}
</style>
